"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Shell = void 0;
const adapter_1 = __importDefault(require("./adapter"));
const SHELL_ABI = require("../../abi/shell.json");
class Shell extends adapter_1.default {
    static getDexData(optimalRate, name) {
        return {
            name,
            srcAmount: optimalRate.srcAmount,
            destAmount: '1',
            exchange: optimalRate.data.exchange,
            deadline: optimalRate.data.deadline
        };
    }
    buildSwap(srcToken, destToken, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const contract = new this.web3Provider.eth.Contract(SHELL_ABI, data.exchange);
            const deadline = data.deadline || this.getDeadline();
            const swapData = contract.methods.originSwap(srcToken, destToken, data.srcAmount, data.destAmount, deadline).encodeABI();
            return this.swap(srcToken, destToken, data, swapData, data.exchange);
        });
    }
}
exports.Shell = Shell;
//# sourceMappingURL=shell.js.map